import { alpha, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  transition: 'background-color 0.2s ease, border-left 0.2s ease',
  cursor: 'pointer',
  position: 'relative',

  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.1 : 0.05),
  },

  // Base background color with better contrast
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.background.paper
      : theme.palette.background.default,

  '&:nth-of-type(even)': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.02)
        : alpha(theme.palette.common.black, 0.02),
  },

  // Selected state styles with higher specificity
  '&.Mui-selected': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? `${alpha(theme.palette.primary.main, 0.3)} !important`
        : `${alpha(theme.palette.primary.main, 0.15)} !important`,
    borderLeft: `4px solid ${theme.palette.primary.main} !important`,
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? `${alpha(theme.palette.primary.main, 0.4)} !important`
          : `${alpha(theme.palette.primary.main, 0.2)} !important`,
    },
    // Override even/odd row styling for selected rows
    '&:nth-of-type(even)': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? `${alpha(theme.palette.primary.main, 0.3)} !important`
          : `${alpha(theme.palette.primary.main, 0.15)} !important`,
    },
    '&:nth-of-type(odd)': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? `${alpha(theme.palette.primary.main, 0.3)} !important`
          : `${alpha(theme.palette.primary.main, 0.15)} !important`,
    },
  },

  // Force text color on all possible elements
  '& .MuiTableCell-root': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& .MuiTypography-root': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& span': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& p': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& div': {
    color: `${theme.palette.text.primary} !important`,
  },
  // Allow exceptions for special elements
  '& .value': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& .measurement span:not(.value)': {
    color: `${theme.palette.text.secondary} !important`,
  },
  '& [class*="Quoted"]': {
    color: `${theme.palette.primary.main} !important`,
  },
  '& .MuiIconButton-root': {
    color: 'inherit',
  },
}));
